/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Data_Export_DescInputs */

const en_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download a copy of all your data in JSON format (GDPR Art. 15/20).`)
};

const de_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie eine Kopie aller Ihrer Daten im JSON-Format herunter (DSGVO Art. 15/20).`)
};

const fr_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telechargez une copie de toutes vos donnees en format JSON (RGPD art. 15/20).`)
};

const es_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga una copia de todos tus datos en formato JSON (RGPD art. 15/20).`)
};

const it_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica una copia di tutti i tuoi dati in formato JSON (GDPR art. 15/20).`)
};

const nl_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download een kopie van al uw gegevens in JSON-formaat (AVG art. 15/20).`)
};

const pl_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz kopie wszystkich swoich danych w formacie JSON (RODO art. 15/20).`)
};

const fi_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa kopio kaikista tiedoistasi JSON-muodossa (GDPR art. 15/20).`)
};

const da_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download en kopi af alle dine data i JSON-format (GDPR art. 15/20).`)
};

const sv_settings_data_export_desc = /** @type {(inputs: Settings_Data_Export_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner en kopia av alla dina data i JSON-format (GDPR art. 15/20).`)
};

/**
* | output |
* | --- |
* | "Download a copy of all your data in JSON format (GDPR Art. 15/20)." |
*
* @param {Settings_Data_Export_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_data_export_desc = /** @type {((inputs?: Settings_Data_Export_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Data_Export_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_data_export_desc(inputs)
	if (locale === "fr") return fr_settings_data_export_desc(inputs)
	if (locale === "es") return es_settings_data_export_desc(inputs)
	if (locale === "it") return it_settings_data_export_desc(inputs)
	if (locale === "nl") return nl_settings_data_export_desc(inputs)
	if (locale === "pl") return pl_settings_data_export_desc(inputs)
	if (locale === "fi") return fi_settings_data_export_desc(inputs)
	if (locale === "da") return da_settings_data_export_desc(inputs)
	if (locale === "sv") return sv_settings_data_export_desc(inputs)
	return en_settings_data_export_desc(inputs)
});